import { MenuList, tabClasses, styled, Tab, Tabs, tabsClasses } from '@mui/material';

export const MenuListStyled = styled(MenuList)(({ theme }) => ({
  color: theme.palette.text.secondary,
  minHeight: 144,
  minWidth: 400,
  maxHeight: 400,
  overflowY: 'auto',
}));

export const TabStyled = styled(Tab)(({ theme }) => ({
  minWidth: 0,
  padding: '4px 12px',
  color: theme.palette.text.secondary,

  [`&.${tabClasses.selected}, &:hover, &:focus`]: {
    color: theme.palette.text.primary,
  },
}));

export const TabsStyled = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey[200]}`,

  [`& .${tabsClasses.indicator}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));
